import Component from '@glimmer/component';
import { type EventInfoComponentArgs } from 'donor-elf-web/components/event/index';
import formatAmount from 'donor-elf-web/helpers/format-amount';

export default class EventInfoAskForIncreaseComponent extends Component<EventInfoComponentArgs> {
  <template>
    <div>
      They have been giving
      {{formatAmount @eventModel.custom.giving_amount removeNoCents=true}}
      for
      {{@eventModel.custom.giving_for_months}}
      months. Consider asking them to increase their donation amount.
    </div>
  </template>
}
